/*
    © 2021 EcomGraduates.com
    https://www.ecomgraduates.com
*/

document.querySelectorAll('.btn-atc').forEach((btn) => {
    btn.addEventListener('click', () => {
        btn.style.width = `${btn.clientWidth}px`;
        btn.insertAdjacentHTML('beforeend', `
            <div class="spinner-border spinner-border-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        `);
        btn.querySelector('span').style.display = 'none';

        setTimeout(() => {
            btn.querySelector('div').remove();
            btn.querySelector('span').style.display = 'block';
        }, 2000);
    });
});

// Smart Cart App events and fixes
document.addEventListener('rebuy:cart.change', (event) => {
    if (event.detail && event.detail.cart) {
        document.querySelectorAll('.cart-count-badge').forEach((badge) => {
            badge.textContent = event.detail.cart.cart.item_count;
        });
    }
});

// Handle ajax 'Add To Cart' (ATC) forms
// window.onSubmitAtcForm = async ($form, event) => {
//     event.preventDefault();

//     $form.classList.add('loading');

//     const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData($form) });

//     if (!response.ok) {
//         setTimeout(() => {
//             document.querySelector('#offcanvas-cart').querySelector('.offcanvas-body')
//                 .insertAdjacentHTML('afterbegin', `
//                     <p 
//                         class="alert alert-warning small mx-4"
//                         style="border-radius: 0; line-height: normal;">
//                         Something went wrong! The product might be out of stock. Please try again later. 
//                         If the issue persist please <a href="/pages/contact">contact us</a>
//                     </p>
//                 `);
//         }, 1500);
//     }

//     $form.classList.remove('loading');
//     // eslint-disable-next-line no-use-before-define
//     loadOffcanvasCart();
// };

// Offcanvas cart - load it on ajax add/update
// const loadOffcanvasCart = async () => {
//     const offcanvasCart = document.querySelector('#offcanvas-cart')
//     const bsOffcanvas = bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart)
//     const offcanvasBody = offcanvasCart.querySelector('.offcanvas-body')

//     offcanvasCart.classList.add('loading')

//     if (!offcanvasCart.classList.contains('show')) {
//         bsOffcanvas.show()
//     }

//     const respoonse = await fetch(window.location.href)
//     const data = await respoonse.text()

//     const parser = new DOMParser()
//     const newDocument = parser.parseFromString(data, 'text/html')

//     offcanvasBody.replaceWith(newDocument.querySelector('#offcanvas-cart .offcanvas-body'))
//     offcanvasCart.querySelector('#cart-subtotal-value').replaceWith(newDocument.querySelector('#cart-subtotal-value'))
//     offcanvasCart.classList.remove('loading')

//     document.querySelectorAll('.cart-count-badge').forEach((badge) => {
//         badge.textContent = newDocument.querySelector('.cart-count-badge').textContent
//     })

//     initQuantityInputs()
//     initRemoveButtons()
//     initCheckoutButton()
//     initCartGoal()
// }

// Quantity inputs
const initQuantityInputs = () => {
    document.querySelectorAll('select[name="updates[]"]').forEach((select) => {
        select.addEventListener('change', async () => {
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: select.dataset.lineItemKey,
                    quantity: select.value,
                }),
            });
            if (document.body.classList.contains('page-type-cart')) {
                window.location.reload();
            } else {
                // loadOffcanvasCart();
            }
        });
    });
};
initQuantityInputs();

// Remove buttons
// const initRemoveButtons = () => {
//     document.querySelectorAll('.btn-remove-line-item').forEach((btn) => {
//         btn.addEventListener('click', async (e) => {
//             await fetch('/cart/change.js', {
//                 method: 'POST',
//                 headers: { 'Content-Type': 'application/json' },
//                 body: JSON.stringify({
//                     id: btn.dataset.lineItemKey,
//                     quantity: 0
//                 })
//             })
//             loadOffcanvasCart()
//         })
//     })
// }
// initRemoveButtons()

// Checkout button - Indicate loading on click
// const initCheckoutButton = () => {
//     document.querySelectorAll('form[action="/cart"] .btn-checkout')
//         .forEach((btn) => {
//             btn.addEventListener('click', (e) => {
//                 btn.style.height = btn.clientHeight + 'px'
//                 btn.innerHTML = `
//                     <div 
//                         class="spinner-border spinner-border-sm" 
//                         role="status"
//                         style="width: 1.2rem; height: 1.2rem">
//                         <span class="visually-hidden">Loading...</span>
//                     </div>
//                 `
//             })
//         })
// }
// initCheckoutButton()

// Footer Upsell (SmartShyp)
// const iniFooterUpsell = async () => {
//     const checkbox = document.querySelector('#offcanvas-cart-footer-upsell-checkbox')

//     const isAlreadyInCart = async () => {
//         const response = await fetch('/cart.json')
//         const data = await response.json()

//         return data.items.some(item => item.id === Number(checkbox.dataset.variantId))
//     }

//     if (checkbox) {
//         checkbox.addEventListener('change', async () => {
//             if (checkbox.checked) {
//                 const isInCart = await isAlreadyInCart()

//                 if (!isInCart) {
//                     await fetch('/cart/add.js', {
//                         method: 'POST',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify({
//                             id: checkbox.dataset.variantId,
//                             quantity: 1
//                         })
//                     })
//                 }
//             } else {
//                 await fetch('/cart/change.js', {
//                     method: 'POST',
//                     headers: { 'Content-Type': 'application/json' },
//                     body: JSON.stringify({
//                         id: checkbox.dataset.variantId,
//                         quantity: 0
//                     })
//                 })
//             }
//             loadOffcanvasCart()
//         })

//         setTimeout(async () => {
//             const userHasSelectedBefore = localStorage.getItem('smartshyp_user_has_selected')
//             if (!userHasSelectedBefore) {
//                 const isInCart = await isAlreadyInCart()

//                 if (!isInCart) {
//                     await fetch('/cart/add.js', {
//                         method: 'POST',
//                         headers: { 'Content-Type': 'application/json' },
//                         body: JSON.stringify({
//                             id: checkbox.dataset.variantId,
//                             quantity: 1
//                         })
//                     })
//                     localStorage.setItem('smartshyp_user_has_selected', true)

//                     checkbox.checked = true

//                     const respoonse = await fetch(window.location.href)
//                     const data = await respoonse.text()

//                     const parser = new DOMParser()
//                     const newDocument = parser.parseFromString(data, 'text/html')

//                     document.querySelector('#cart-subtotal-value').replaceWith(newDocument.querySelector('#cart-subtotal-value'))
//                 }
//             }
//         }, 2000)
//     }
// }
// iniFooterUpsell()

// Cart Goal - Animate width
// const initCartGoal = () => {
//     const progressBar = document.querySelector('#cart-goal .progress-bar')
//     if (progressBar) {
//         setTimeout(() => {
//             progressBar.style.width = progressBar.dataset.width
//         }, 250)
//     }
// }
// initCartGoal()

// Offcanvas cart - Open it if URL contains '#cart'
// if (window.location.hash.includes('#cart')) {
//     const offcanvasCart = bootstrap.Offcanvas.getOrCreateInstance('#offcanvas-cart')
//     offcanvasCart.show()
// }

// Shuffle (randomize) upsell product lists in the offcanvas cart
// const shuffleOffcanvasCartUpsells = () => {
//     const list1 = document.querySelector('#cart-single-product-upsell')
//     const list2 = document.querySelector('#offcanvas-cart-upsell-collection')

//     if (list1) {
//         for (let i = list1.children.length; i >= 0; i--) {
//             list1.appendChild(list1.children[Math.random() * i | 0])
//         }
//     }

//     if (list2) {
//         for (let i = list2.children.length; i >= 0; i--) {
//             list2.appendChild(list2.children[Math.random() * i | 0])
//         }
//     }
// }
// shuffleOffcanvasCartUpsells()
